module.exports = __webpack_public_path__ + "img/calendar_date.c4a39484.svg";